import { useEffect, useState } from "react"
import { api } from "@/shared/api-client"

interface Ev {
  id: number
  ts: number
  sev: string
  source: string
  message: string
  count: number
}
interface Data {
  available: boolean
  running: boolean
  feeds_updated: number | null
  last_scan: { ts: number; found: number } | null
  events: Ev[]
}

const COLOR: Record<string, string> = { warning: "text-amber-400", high: "text-orange-400", critical: "text-rose-400" }
const fmt = (t: number) => new Date(t * 1000).toLocaleString("ru-RU")

/** Владелец: состояние и последние тревоги «Стража» (только просмотр). */
export function GuardCard() {
  const [d, setD] = useState<Data | null>(null)
  useEffect(() => {
    api.get<Data>("/guard/events").then(setD).catch(() => setD(null))
  }, [])
  if (!d) return null
  return (
    <div className="box overflow-hidden p-5 space-y-3">
      <div>
        <h2 className="text-sm font-semibold text-zinc-200">Страж</h2>
        <p className="text-xs text-zinc-500 mt-0.5">
          {d.available ? (d.running ? "Работает." : "Не отвечает — проверьте службу.") : "Ещё не запущен."} Только наблюдение и
          оповещение; сам ничего не блокирует.
          {d.feeds_updated ? ` Списки угроз обновлены: ${fmt(d.feeds_updated)}.` : ""}
          {d.last_scan ? ` Последняя проверка файлов: ${fmt(d.last_scan.ts)}, находок: ${d.last_scan.found}.` : ""}
        </p>
      </div>
      {d.events.length === 0 && d.available && <p className="text-sm text-zinc-500">Тревог нет.</p>}
      {d.events.map((e) => (
        <div key={e.id} className="text-sm border-b border-white/5 pb-1.5">
          <span className={COLOR[e.sev] ?? "text-zinc-300"}>{e.sev}</span> · {e.message}
          <span className="block text-xs text-zinc-500">
            {fmt(e.ts)} · {e.source}
            {e.count > 1 ? ` · повторов: ${e.count}` : ""}
          </span>
        </div>
      ))}
    </div>
  )
}
